export default __webpack_public_path__ + "static/plank-back-f605ebd8b24d17e4f00c5ef3fd927d2a.webp";